import { __read } from "tslib";
import React, { useState, useEffect } from 'react';
var Delayed = function (_a) {
    var children = _a.children;
    var _b = __read(useState(false), 2), visible = _b[0], setVisibility = _b[1];
    useEffect(function () { return setVisibility(true); }, []);
    return React.createElement(React.Fragment, null, visible && children);
};
export default Delayed;
